export default {
  alignContent: ['flex-start', 'flex-end', 'stretch', 'space-between', 'space-around'],
  alignItems: ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'],
  justifyContent: [
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'space-evenly',
  ],
  flexWrap: ['nowrap', 'wrap', 'wrap-reverse'],
  flexDirection: ['row', 'row-reverse', 'column', 'column-reverse'],
}
